import React from 'react';

import classes from './Scrollbar.module.css';

const Scrollbar = (props) => {
	return (
		<div
			className={classes.Scrollbar}
			style={{
				overflowX: !props.overflowX ? 'hidden' : props.overflowX,
				overflowY: !props.overflowY ? 'hidden' : props.overflowY,
			}}
		>
			<div className={classes.Scrollbar_Content}>{props.children}</div>
		</div>
	);
};

export default Scrollbar;
